(function(){
var rss = require('./rss');
var dom = require('./dom'), doc=dom.doc;

rss.set_max('blog', 15);
rss.set_max('forum', 15);
var rss_div = doc.id("rss");
rss_div.className="ancillary";
rss_div.parentNode.removeChild(rss_div);
doc.id("news").parentNode.replaceChild(rss_div, doc.id("news"));
})()(function(){
var rss = require('./rss');
var dom = require('./dom'), doc=dom.doc;

rss.set_max('blog', 15);
rss.set_max('forum', 15);
var rss_div = doc.id("rss");
rss_div.className="ancillary";
rss_div.parentNode.removeChild(rss_div);
doc.id("news").parentNode.replaceChild(rss_div, doc.id("news"));
})()